import type { IResponseDbConfigData } from './type'
import { create } from '@eureka/utils/deferred'
import { getDbConfig } from './country.api'

export const dbConfigDeferred = create<IResponseDbConfigData>()

getDbConfig().then(data => {
    dbConfigDeferred.resolve(data)
})
